export const MAX_MONEY = 1000000000;
export const MAX_REPORT = 999999;